import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE } from '../constants';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE,
      method: 'get',
      request: communityId => ({
        url: addParametersToUri(apiRoutes.onboardingTemplates(), { communityId }),
      }),
    },
  ])(ComposedComponent);
